export default {
  methods: {
    queryParams(data) {
      const keyName = (prefix, key) => prefix ? prefix + '.' + key : key

      function params(obj, prefix) {
        var str = []
        for (var key in obj) {
          let value = obj[key]
          if (value) {
            if (value instanceof Array && obj.hasOwnProperty(key)) {
              value.forEach(item => {
                str.push(encodeURIComponent(keyName(prefix, key)) + "[]=" + encodeURIComponent(item))
              })
            } else if (typeof value === 'object' && obj.hasOwnProperty(key)) {
              str.push(params(value, key))
            }
            else
              str.push(encodeURIComponent(keyName(prefix, key)) + "=" + encodeURIComponent(obj[key]))
          }
        }
        return str.join("&")
      }

      return params(data)
    }
  }
}
